"use strict";
/* eslint-disable max-lines */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prebuiltNewHireOnboarding = void 0;
const templateUtils_1 = require("../../templateUtils");
const triggerFormContent = {
    subject: 'New Hire Onboarding Survey',
    contentType: 'html',
    contentData: [
        {
            type: 'display-image',
            version: '1',
            id: 'fcba7887-4fcb-40c2-b51b-8af9b2e08b60',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/New-Hire-Onboarding-Survey.png',
                width: 100,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
                paddingLeft: 0,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: 'fa221c95-7115-42c3-8e25-e955de6ec269',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '1. Which department do you work in? ',
                options: [
                    {
                        label: 'Department 1',
                        id: 'fa22599d-ac6b-4522-9eae-ef695c1779ea',
                        value: false,
                    },
                    {
                        label: 'Department 2',
                        id: '9f0e6304-0bc1-44ed-a4ed-ff6b661b03d5',
                        value: false,
                    },
                    {
                        label: 'Department 3',
                        id: 'd7e5eb55-31ac-445c-b7d9-42b7fb922a52',
                        value: false,
                    },
                    {
                        id: '0243e029-e39b-4ff0-b3ae-e3cdda1228a3',
                        label: 'Department 4',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: '21cc0794-caac-497a-a978-9c2f5e2cca7a',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '2. Overall, how valuable was the new hire onboarding at our company?',
                options: [
                    {
                        label: 'Extremely valuable',
                        id: 'fa22599d-ac6b-4522-9eae-ef695c1779ea',
                        value: false,
                    },
                    {
                        label: 'Very valuable',
                        id: '9f0e6304-0bc1-44ed-a4ed-ff6b661b03d5',
                        value: false,
                    },
                    {
                        label: 'Somewhat valuable',
                        id: 'd7e5eb55-31ac-445c-b7d9-42b7fb922a52',
                        value: false,
                    },
                    {
                        id: '0243e029-e39b-4ff0-b3ae-e3cdda1228a3',
                        label: 'Not so valuable',
                        value: false,
                    },
                    {
                        id: 'a77e33f5-e3c4-4e6c-b372-c8fae4e2475c',
                        label: 'Not valuable at all',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: '060784a6-eb65-4190-b0e2-ddbc1c3ed3e5',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '3. Prior to your first day at work, did you feel you had all the necessary information such as the schedule of the onboarding process?',
                options: [
                    {
                        label: 'Yes',
                        id: 'fa22599d-ac6b-4522-9eae-ef695c1779ea',
                        value: false,
                    },
                    {
                        label: 'No',
                        id: '9f0e6304-0bc1-44ed-a4ed-ff6b661b03d5',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-text-input',
            version: '1',
            id: '9d08daf2-2709-41e9-a455-c995eef35235',
            data: {
                backgroundColor: '#ffffff',
                label: '4. What else would have been helpful for you to know to get you started?',
                requiredField: true,
                helperText: '',
                defaultValue: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                placeholder: 'Enter Text',
                textInputType: 'text',
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: 'deec6969-f452-4835-ad3d-3b1870c2e40a',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '5. How clear did you find the information presented during the onboarding?',
                options: [
                    {
                        label: 'Extremely clear',
                        id: 'fa22599d-ac6b-4522-9eae-ef695c1779ea',
                        value: false,
                    },
                    {
                        label: 'Very clear',
                        id: '9f0e6304-0bc1-44ed-a4ed-ff6b661b03d5',
                        value: false,
                    },
                    {
                        label: 'Somewhat clear',
                        id: 'd7e5eb55-31ac-445c-b7d9-42b7fb922a52',
                        value: false,
                    },
                    {
                        id: '0243e029-e39b-4ff0-b3ae-e3cdda1228a3',
                        label: 'Not so clear',
                        value: false,
                    },
                    {
                        id: 'a77e33f5-e3c4-4e6c-b372-c8fae4e2475c',
                        label: 'Not clear at all',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: '4bb936d9-1c2e-4d33-94eb-9398fb302bc5',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '6. Should onboarding have been longer, shorter or was it just about right?',
                options: [
                    {
                        label: 'Longer',
                        id: 'fa22599d-ac6b-4522-9eae-ef695c1779ea',
                        value: false,
                    },
                    {
                        label: 'Shorter',
                        id: '9f0e6304-0bc1-44ed-a4ed-ff6b661b03d5',
                        value: false,
                    },
                    {
                        label: 'Just about right',
                        id: 'd7e5eb55-31ac-445c-b7d9-42b7fb922a52',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: '8320d454-3c77-4a83-9443-6cae6b6202ef',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '7. Was your computer equipment ready when you arrived at the office on your first day?',
                options: [
                    {
                        label: 'Yes',
                        id: 'fa22599d-ac6b-4522-9eae-ef695c1779ea',
                        value: false,
                    },
                    {
                        label: 'No',
                        id: '9f0e6304-0bc1-44ed-a4ed-ff6b661b03d5',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-text-area',
            version: '1',
            id: '54da78d6-5c7d-4885-b4ac-efdd2a592e98',
            data: {
                backgroundColor: '#ffffff',
                label: 'Any further comments regarding the onboarding process? ',
                requiredField: true,
                helperText: '',
                defaultValue: '',
                inputFieldHeight: 4,
                placeholder: 'Enter Text',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
            },
        },
        {
            type: 'form-submit-button',
            version: '1',
            id: '568ee058-d4f6-4d20-88a4-85a9b6b4d216',
            data: {
                backgroundColor: '#FFFFFF',
                borderColor: '#1515FF',
                borderRadius: 4,
                buttonColor: '#1515FF',
                color: '#FFFFFF',
                fontSize: 14,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                paddingTop: 10,
                text: 'Submit',
                textAlign: 'center',
                width: 200,
            },
        },
    ],
    inputVariables: [],
    outputVariables: [
        {
            id: 'fa221c95-7115-42c3-8e25-e955de6ec269',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '1. Which department do you work in? ',
            options: [
                {
                    label: 'Department 1',
                    id: 'fa22599d-ac6b-4522-9eae-ef695c1779ea',
                    value: false,
                },
                {
                    label: 'Department 2',
                    id: '9f0e6304-0bc1-44ed-a4ed-ff6b661b03d5',
                    value: false,
                },
                {
                    label: 'Department 3',
                    id: 'd7e5eb55-31ac-445c-b7d9-42b7fb922a52',
                    value: false,
                },
                {
                    id: '0243e029-e39b-4ff0-b3ae-e3cdda1228a3',
                    label: 'Department 4',
                    value: false,
                },
            ],
        },
        {
            id: '21cc0794-caac-497a-a978-9c2f5e2cca7a',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '2. Overall, how valuable was the new hire onboarding at our company?',
            options: [
                {
                    label: 'Extremely valuable',
                    id: 'fa22599d-ac6b-4522-9eae-ef695c1779ea',
                    value: false,
                },
                {
                    label: 'Very valuable',
                    id: '9f0e6304-0bc1-44ed-a4ed-ff6b661b03d5',
                    value: false,
                },
                {
                    label: 'Somewhat valuable',
                    id: 'd7e5eb55-31ac-445c-b7d9-42b7fb922a52',
                    value: false,
                },
                {
                    id: '0243e029-e39b-4ff0-b3ae-e3cdda1228a3',
                    label: 'Not so valuable',
                    value: false,
                },
                {
                    id: 'a77e33f5-e3c4-4e6c-b372-c8fae4e2475c',
                    label: 'Not valuable at all',
                    value: false,
                },
            ],
        },
        {
            id: '060784a6-eb65-4190-b0e2-ddbc1c3ed3e5',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '3. Prior to your first day at work, did you feel you had all the necessary information such as the schedule of the onboarding process?',
            options: [
                {
                    label: 'Yes',
                    id: 'fa22599d-ac6b-4522-9eae-ef695c1779ea',
                    value: false,
                },
                {
                    label: 'No',
                    id: '9f0e6304-0bc1-44ed-a4ed-ff6b661b03d5',
                    value: false,
                },
            ],
        },
        {
            id: '9d08daf2-2709-41e9-a455-c995eef35235',
            valueType: 'string',
            inputType: 'form-text-input',
            label: '4. What else would have been helpful for you to know to get you started?',
        },
        {
            id: 'deec6969-f452-4835-ad3d-3b1870c2e40a',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '5. How clear did you find the information presented during the onboarding?',
            options: [
                {
                    label: 'Extremely clear',
                    id: 'fa22599d-ac6b-4522-9eae-ef695c1779ea',
                    value: false,
                },
                {
                    label: 'Very clear',
                    id: '9f0e6304-0bc1-44ed-a4ed-ff6b661b03d5',
                    value: false,
                },
                {
                    label: 'Somewhat clear',
                    id: 'd7e5eb55-31ac-445c-b7d9-42b7fb922a52',
                    value: false,
                },
                {
                    id: '0243e029-e39b-4ff0-b3ae-e3cdda1228a3',
                    label: 'Not so clear',
                    value: false,
                },
                {
                    id: 'a77e33f5-e3c4-4e6c-b372-c8fae4e2475c',
                    label: 'Not clear at all',
                    value: false,
                },
            ],
        },
        {
            id: '4bb936d9-1c2e-4d33-94eb-9398fb302bc5',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '6. Should onboarding have been longer, shorter or was it just about right?',
            options: [
                {
                    label: 'Longer',
                    id: 'fa22599d-ac6b-4522-9eae-ef695c1779ea',
                    value: false,
                },
                {
                    label: 'Shorter',
                    id: '9f0e6304-0bc1-44ed-a4ed-ff6b661b03d5',
                    value: false,
                },
                {
                    label: 'Just about right',
                    id: 'd7e5eb55-31ac-445c-b7d9-42b7fb922a52',
                    value: false,
                },
            ],
        },
        {
            id: '8320d454-3c77-4a83-9443-6cae6b6202ef',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '7. Was your computer equipment ready when you arrived at the office on your first day?',
            options: [
                {
                    label: 'Yes',
                    id: 'fa22599d-ac6b-4522-9eae-ef695c1779ea',
                    value: false,
                },
                {
                    label: 'No',
                    id: '9f0e6304-0bc1-44ed-a4ed-ff6b661b03d5',
                    value: false,
                },
            ],
        },
        {
            id: '54da78d6-5c7d-4885-b4ac-efdd2a592e98',
            valueType: 'string',
            inputType: 'form-text-area',
            label: 'Any further comments regarding the onboarding process? ',
        },
    ],
    workspaceId: 'FAA4358B519D0E89',
};
const prebuiltNewHireOnboarding = (workspaceId, request) => __awaiter(void 0, void 0, void 0, function* () {
    return [
        {
            id: 0,
            variables: {
                input: [],
                output: [
                    {
                        variableName: '1. Which department do you work in? ',
                        variableId: 'fa221c95-7115-42c3-8e25-e955de6ec269',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Department 1","checked":"false"},{"id":2,"text":"Department 2","checked":"false"},{"id":3,"text":"Department 3","checked":"false"},{"id":"ab376685-1bc5-4d84-ab50-0a7bbeb5e4bb","text":"Department 4","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: '2. Overall, how valuable was the new hire onboarding at our company?',
                        variableId: '21cc0794-caac-497a-a978-9c2f5e2cca7a',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Extremely valuable ","checked":"false"},{"id":2,"text":"Very valuable ","checked":"false"},{"id":3,"text":"Somewhat valuable ","checked":"false"},{"id":"39356ce5-b0b3-46e5-b04b-18474a692a4e","text":" Not so valuable","checked":"false"},{"id":"90f2068d-3532-48bb-9e94-7386428c9bfe","text":"Not valuable at all","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: '3. Prior to your first day at work, did you feel you had all the necessary information such as the schedule of the onboarding process?',
                        variableId: '060784a6-eb65-4190-b0e2-ddbc1c3ed3e5',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Yes ","checked":"false"},{"id":2,"text":"No","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: '4. What else would have been helpful for you to know to get you started?',
                        variableId: '9d08daf2-2709-41e9-a455-c995eef35235',
                        variableType: 'string',
                        type: 'FormTextInput',
                    },
                    {
                        variableName: '5. How clear did you find the information presented during the onboarding?',
                        variableId: 'deec6969-f452-4835-ad3d-3b1870c2e40a',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Extremely clear ","checked":"false"},{"id":2,"text":"Very clear ","checked":"false"},{"id":3,"text":"Somewhat clear ","checked":"false"},{"id":"c7de88b9-caf7-4b57-92e7-c2c65824d076","text":"Not so clear ","checked":"false"},{"id":"32d9b028-224d-4765-bd93-06e83079ee84","text":"Not clear at all","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: '6. Should onboarding have been longer, shorter or was it just about right?',
                        variableId: '4bb936d9-1c2e-4d33-94eb-9398fb302bc5',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Longer ","checked":"false"},{"id":2,"text":"Shorter","checked":"false"},{"id":3,"text":" Just about right","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: '7. Was your computer equipment ready when you arrived at the office on your first day?',
                        variableId: '8320d454-3c77-4a83-9443-6cae6b6202ef',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Yes","checked":"false"},{"id":2,"text":"No","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: 'Any further comments regarding the onboarding process? ',
                        variableId: '54da78d6-5c7d-4885-b4ac-efdd2a592e98',
                        variableType: 'string',
                        type: 'FormTextInput',
                    },
                ],
            },
            type: 'start',
            next: null,
            isDirty: true,
            version: '1.0.2',
            data: {
                stepName: 'Trigger',
                triggers: [
                    {
                        id: 0,
                        type: 'form',
                        data: {
                            form: yield (0, templateUtils_1.getContentData)({
                                request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, triggerFormContent), { workspaceId })); }),
                            }),
                        },
                    },
                ],
            },
        },
    ];
});
exports.prebuiltNewHireOnboarding = prebuiltNewHireOnboarding;
//# sourceMappingURL=newHireOnboarding.js.map